import React, { useState } from "react";
import "./Modal.css";

/**
 * Modal for creating a new API user.
 * Collects name and email, submits to the backend, and triggers
 * a private key download on success.
 */
function CreateUserModal({ onClose, onSubmit, loading }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!name.trim()) {
      setError("Name is required.");
      return;
    }
    if (!email.trim() || !email.includes("@")) {
      setError("A valid email is required.");
      return;
    }

    try {
      await onSubmit({ name: name.trim(), email: email.trim() });
    } catch (err) {
      setError(err.message || "Failed to create user.");
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Create New User</h2>
          <button className="modal-close" onClick={onClose}>
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {error && <div className="modal-error">{error}</div>}

            <div className="modal-field">
              <label htmlFor="create-name">Name</label>
              <input
                id="create-name"
                type="text"
                placeholder="Enter user name"
                maxLength={24}
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoFocus
              />
              <span className="modal-field-hint">Max 24 characters</span>
            </div>

            <div className="modal-field">
              <label htmlFor="create-email">Email</label>
              <input
                id="create-email"
                type="email"
                placeholder="Enter user email"
                maxLength={56}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <span className="modal-field-hint">Max 56 characters</span>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? "Creating..." : "Create User"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateUserModal;
